import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AwsAuthService {

  public isUserLoggedIn: boolean = false;
  public code: any;

  private readonly _loginStatus = signal<boolean>(false);
  private readonly _loginStatus$ = toObservable(this._loginStatus);
  public disableMultipleClicks: boolean = false;
  public API_ENDPOINT = environment.proxyEndpoint
  private userCountryRegion = localStorage.getItem('countryOfOrigin') ?? '';

  constructor(private readonly _httpClient: HttpClient, private readonly _route: ActivatedRoute) {
    if (this.userCountryRegion !== '') {
      const userCountryData = JSON.parse(this.userCountryRegion);
      const region = userCountryData.region;

      if (region === 'amap') {
        this.API_ENDPOINT = environment.proxyAmapEndpoint
      }
    }
    this.getAuthCode();
  }

  public signIn(): Observable<any> {
    const userCountry: {code: string, region: string} | any = JSON.parse(localStorage.getItem('countryOfOrigin') ?? "{code: 'DE', region: 'ece'}")
    const url =  this.API_ENDPOINT + '/auth/federatedSignIn?country='+userCountry.code+'&region='+userCountry.region;
    return this._httpClient.get<any>(url);
  }

  public manageLoginResponse(): void {
  if (this.disableMultipleClicks) {
    return;
  }

  this.disableMultipleClicks = true;

  const userCountry: { code: string; region: string } =
    JSON.parse(localStorage.getItem('countryOfOrigin') ?? '{"code":"DE","region":"ece"}');

  // Direct navigation — query params preserved, no XHR, loginUrl never exposed to JS
  window.location.href =
    this.API_ENDPOINT +
    '/auth/federatedSignIn?country=' +
    encodeURIComponent(userCountry.code) +
    '&region=' +
    encodeURIComponent(userCountry.region);

  setTimeout(() => {
    this.disableMultipleClicks = false;
  }, 3000);
}

  public getAuthCode(): void {
    this._route?.queryParams?.subscribe((params: { [x: string]: any; }) => {
      this.code = params['code'];
      if (this.code) {
        this.callGenerateAuthTokenApi(this.code).subscribe(response => {
          if (response) {
            this.disableMultipleClicks = false;
            this.setUserLoggedInStatus();
            const responseBody = response.body
            this.isLoginSucess = responseBody.success
          }
        });
      }
    });
  }

  public callGenerateAuthTokenApi(code: any): Observable<any> {
    const url = `${ this.API_ENDPOINT}/auth/token?code=${code}`;
    return this._httpClient.get<any>(url, {observe: 'response', withCredentials: true});
  }

  public logout() {
    this.clearLocalStorageItems();
    const url =  this.API_ENDPOINT + '/auth/signout';
    return this._httpClient.get<any>(url);
  }

  public manageLogoutResponse(): void {
    this.logout().subscribe((response: any) => {
      window.location.href = response.logout_uri
    });
  }

  public setUserLoggedInStatus(): void {
    localStorage.setItem('isLoggedIn', 'true');
  }

  public getUserLoggedInStatus(): boolean {
    return localStorage.getItem('isLoggedIn') === 'true' || false;
  }

  public clearLocalStorageItems() {
    localStorage.removeItem('isBasicAuthSuccess');
    localStorage.removeItem('isLoggedIn');
  }

  public set isLoginSucess(success: boolean) {
    this._loginStatus.set(success);
  }

  public get isLoginSuccess() {
    return this._loginStatus$;
  }

}
